import { Component, ChangeDetectionStrategy, DestroyRef, ElementRef, AfterViewInit, inject, input, viewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { IStream } from "@auvious/rtc";
import { filter } from "rxjs/operators";
import { debug, VoiceDetectionService } from "../../services";
@Component({
  selector: "app-volume-indicator",
  templateUrl: "./volume-indicator.component.html",
  styleUrls: ["./volume-indicator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VolumeIndicatorComponent implements AfterViewInit {
  private voiceDetectionService = inject(VoiceDetectionService);
  private destroyRef = inject(DestroyRef);

  readonly volumeElem = viewChild<ElementRef<HTMLDivElement>>("volumeRef");

  readonly stream = input<IStream>(undefined);
  readonly muted = input<boolean>(undefined);

  mutliplier = 1.3;
  level = 0;

  ngAfterViewInit() {
    this.voiceDetectionService.volumeLevel$
      .pipe(filter((v) => v.streamId === this.stream().id), takeUntilDestroyed(this.destroyRef))
      .subscribe((volume) => {
        const volumeElem = this.volumeElem();
        if (volumeElem) {
          volumeElem.nativeElement.style.height =
            // volume.level * this.mutliplier + "px";
            volume.level + "%";
        }
      });
  }
}
